import React from 'react'

const UserGroupMap = () => {
  return <div>UserGroupMap</div>
}

export default UserGroupMap
